import withConfigTransport from '../../services/config-transport/withConfigTransport'
import VaCheckbox from './VaCheckbox.vue'

export default withConfigTransport(VaCheckbox)
